<template>
  <div class="parent">
    <transition name="toast" @after-leave="closed">
      <div
          v-if="open"
          class="toast alert"
          :class="alert_class"
      >
        <button type="button" class="close" aria-label="Close" @click="close">
          <span aria-hidden="true">&times;</span>
        </button>
        {{ message }}
      </div>
    </transition>
  </div>
</template>

<style scoped>
  .parent {
    position: absolute;
  }

  .toast {
    position: fixed;
    top: 30px;
    left: 50vw;
    transform: translateX(-50%);

    width: 30vw;

    z-index: 10001;
  }

  .toast-enter, .toast-leave-to {
    top: -200px;
  }

  .toast-enter-active, .toast-leave-active {
    transition: top .2s ease-out;
  }
</style>

<script>
  export default {
    data() {
      return {
        timer: -1,
        open: false,
      }
    },
    created() {
      this.timer = setTimeout(() => {
        this.close();
      }, this.time * 1000);
    },
    mounted() {
      this.open = true;
    },
    props: {
      type: {
        type: String,
        default: "success",
      },
      time: {
        type: Number,
        default: 5,
      },
      message: {
        type: String,
        default: "",
      }
    },
    computed: {
      alert_class() {
        return ["alert-" + this.type];
      },
    },
    methods: {
      close() {
        this.open = false;
        clearTimeout(this.timer);
      },
      closed() {
        this.$emit("closed");
      },
    },
  }
</script>



// WEBPACK FOOTER //
// assets/vue/Toast.vue?047386bc